import React from 'react';

const ToolbarRow = (props) => (
  <div className='toolbar_row' {...props} />
);

export default ToolbarRow;
